export default __webpack_public_path__ + "static/media/29.d112bb55.png";